import PropTypes from "prop-types";
import React from "react";
import { FormLabel, FormControl, FormGroup } from "react-bootstrap";
import { DropTarget } from "react-dnd";

const boxTarget = {
  drop(props, monitor) {
    if (props.onDrop) {
      props.onDrop(props, monitor);
    }
  },
};

function collect(connect, monitor) {
  return {
    canDrop: monitor.canDrop(),
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  };
}

class FileDropBox extends React.Component {
  static get displayName() {
    return "FileDropBox";
  }

  static get propTypes() {
    return {
      accepts: PropTypes.arrayOf(PropTypes.string).isRequired,
      canDrop: PropTypes.bool.isRequired,
      connectDropTarget: PropTypes.func.isRequired,
      isOver: PropTypes.bool.isRequired,
      onDrop: PropTypes.func,
      onBrowse: PropTypes.func,
    };
  }

  _renderPlaceholder() {
    return (
      <span>
        {" "}
        Drag Files Here or
        <FormGroup controlId="file" className="file-drop-area-browse">
          <FormLabel>Browse</FormLabel>
          <FormControl
            type="file"
            ref={(ref) => {
              this.fileInput = ref;
            }}
            onChange={this.props.onBrowse}
            multiple
          />
        </FormGroup>
      </span>
    );
  }

  render() {
    const { canDrop, connectDropTarget, isOver } = this.props;
    const isActive = canDrop && isOver;
    return connectDropTarget(
      <div className="file-drop-area">
        <div className="file-drop-area-placeholder">
          {isActive ? "Release files to drop" : this._renderPlaceholder()}
        </div>
      </div>,
    );
  }
}

module.exports = new DropTarget((props) => props.accepts, boxTarget, collect)(
  FileDropBox,
);
